
import { useState } from "react";
import { submitLead } from "../lib/api.js";

export default function LeadForm({
  t,
  type = "enquiry",
  product = "",
  title
}) {
  const [form, setForm] = useState({
    name: "",
    mobile: "",
    email: "",
    product,
    message: ""
  });

  const [status, setStatus] = useState("");
  const [statusType, setStatusType] = useState("");

  function update(event) {
    setForm((current) => ({
      ...current,
      [event.target.name]: event.target.value
    }));
  }

  async function onSubmit(event) {
    event.preventDefault();

    setStatusType("");
    setStatus("Sending enquiry...");

    try {
      const response = await submitLead(type, form);

      console.log("Lead Submitted:", response);

      setStatusType("success");
      setStatus("✅ Enquiry submitted successfully. Our team will contact you shortly.");

      setForm({
        name: "",
        mobile: "",
        email: "",
        product,
        message: ""
      });

    } catch (error) {
      console.error("Lead Submission Error:", error);

      setStatusType("error");

      setStatus(
        error?.response?.data?.message ||
        error?.message ||
        "Unable to submit. Please try again."
      );
    }
  }

  return (
    <form
      className="premium-card grid gap-4 p-5"
      onSubmit={onSubmit}
    >
      <h2 className="text-2xl font-black text-royal">
        {title || t.sections.enquiry}
      </h2>

      <input
        className="focus-ring rounded-xl border border-[var(--line)] px-4 py-3"
        name="name"
        value={form.name}
        onChange={update}
        placeholder={t.forms.name}
        required
      />

      <input
        className="focus-ring rounded-xl border border-[var(--line)] px-4 py-3"
        name="mobile"
        value={form.mobile}
        onChange={update}
        placeholder={t.forms.mobile}
        required
      />

      <input
        className="focus-ring rounded-xl border border-[var(--line)] px-4 py-3"
        name="email"
        type="email"
        value={form.email}
        onChange={update}
        placeholder={t.forms.email}
        required
      />

      <input
        className="focus-ring rounded-xl border border-[var(--line)] px-4 py-3"
        name="product"
        value={form.product}
        onChange={update}
        placeholder={t.forms.product}
      />

      <textarea
        className="focus-ring min-h-28 rounded-xl border border-[var(--line)] px-4 py-3"
        name="message"
        value={form.message}
        onChange={update}
        placeholder={t.forms.message}
      />

      <button
        type="submit"
        className="focus-ring rounded-xl bg-gradient-to-r from-[#8C4444] to-[#A05252] px-5 py-3 font-black text-white shadow-md transition-all hover:scale-105"
      >
        {t.actions.send}
      </button>

      {status && (
        <p
          className={`text-sm font-bold ${
            statusType === "success"
              ? "text-green-600"
              : statusType === "error"
              ? "text-red-600"
              : "text-royal"
          }`}
        >
          {status}
        </p>
      )}
    </form>
  );
}

